const loyaltyPointsCalculator = require('../../common/loyalty/loyalty-points-calculator');

class CartLoyaltyController {
    constructor(featureService, settingsService, trolleyService) {
        this.trolleyService = trolleyService;
        this.settingsService = settingsService;
        this.featureService = featureService;
        settingsService.getSettingValue('EverydayRewards', 'CardName').then((setting) => {
            this.rewardsCardName = setting;
        });
    }

    isOptOutSaveForLaterAndBalanceIsLessThanMinimum() {
        return !this.shouldShowSaveForLaterPreference() && this.isLowerThanMinimumRedemptionBalance();
    }

    getToSpendImageProperties() {
        if (!this.shouldShowSaveForLaterPreference()) {
            return { srcName: 'icon-rewards-burn.svg', className: 'cartLoyalty-pointsToSpendIcon' };
        } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
            return { srcName: 'icon-rewards-qff-plane.svg', className: 'cartLoyalty-pointsQffIcon' };
        } else if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
            return { srcName: 'icon-rewards-xmas-sock.svg', className: 'cartLoyalty-pointsXmasIcon' };
        }
        return { srcName: 'icon-tospend.png', className: 'cartLoyalty-pointsToSpendIcon' };
    }

    shouldShowSaveForLaterPreference() {
        return this.getSaveForLaterPreference() === 'Christmas' || this.getSaveForLaterPreference() === 'QuarterlyQff';
    }

    getToSpendDisplayMessage() {
        if (this.getSaveForLaterPreference() === 'QuarterlyQff') {
            return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR QANTAS' : 'SAVED FOR QANTAS';
        }
        if (this.getSaveForLaterPreference() === 'Christmas') {
            return this.isLowerThanMinimumRedemptionBalance() ? 'SAVING<br/>FOR XMAS' : 'SAVED FOR XMAS';
        }
        return 'TO SPEND';
    }

    getScreenReaderMessage() {
        if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'QuarterlyQff') {
            return 'to save for Qantas';
        }
        if (this.shouldShowSaveForLaterPreference() && this.getSaveForLaterPreference() === 'Christmas') {
            return 'to save for Christmas';
        }
        return 'to spend';
    }

    getLowerThanMinimumBalanceStyle() {
        return this.isLowerThanMinimumRedemptionBalance() ? 'cartLoyalty-pointsTopRowLowerThanMinimumBalance' : '';
    }

    isLowerThanMinimumRedemptionBalance() {
        return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsLessThanMinimumRedemptionBalance;
    }

    getWowRewardsEarned() {
        return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsEarned;
    }

    getWowRewardsToSpend() {
        return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.WowRewardsToSpend;
    }

    getRewardsPoints() {
        return loyaltyPointsCalculator(this.getWowRewardsEarned());
    }

    getSaveForLaterPreference() {
        return this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.SaveForLaterPreference;
    }

    shouldShowWowRewardsSummary() {
        const isEnabledGetEdrPointsBalanceOnLogin =
            this.featureService.isEnabled(this.featureService.features.enableGetEdrPointsBalanceOnLogin);
        const isErrorInGettingWowRewardsBalance =
            this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsErrorInGettingWowRewardsBalance;
        const isRegisteredWowRewardsCustomer =
            this.trolleyService.wowRewardsSummary && this.trolleyService.wowRewardsSummary.IsWowRewardsCardRegistered;

        return isEnabledGetEdrPointsBalanceOnLogin && !isErrorInGettingWowRewardsBalance && isRegisteredWowRewardsCustomer;
    }
}

const cartLoyaltyComponentDefinition = {
    controller: ['FeatureService', 'SettingsService', 'TrolleyService', CartLoyaltyController],
    template: require('./cart-loyalty.component.html').trim(),
};

module.exports = {
    CartLoyaltyController,
    cartLoyaltyComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-loyalty.component.js